import { FormulaTree } from "utils/services";

import { useMemo } from "react";
import BracketsRender from "../BracketsComponent/BracketsRender";
import { FunctionRender } from "../FunctionRender";
import { OperatorComponent } from "../OperatorComponent";
import { VariableComponent } from "../VariableComponent";
import { FormulaSelect } from "../FormulaSelect";
import { ObjectFilterByKeys } from "utils/helpers";
import FormulaLabel from "../FormulaLabel/FormulaLabel";

const NodeRender = ({
  dropdownData,
  node,
  autoActiveInputs,
  onUpdateItem,
  onDeleteItem,
  onSelectItem,
  RecursiveRenderComponent,
  withEndInput,
}) => {

  const dropdownDataToComponent = useMemo(() => {
    return ObjectFilterByKeys({
      object: dropdownData,
      keys: node.nextNodeType,
    });
  }, [dropdownData, node]);

  const dropdownDataToAdditionalInput = useMemo(() => {
    return ObjectFilterByKeys({
      object: dropdownData,
      keys: [FormulaTree.NODE_TYPES.Operator],
    });
  }, [dropdownData]);

  const selectItemsHandler = onSelectItem(node.id);

  switch (node.type) {
    case FormulaTree.NODE_TYPES.Function:
      return (
        <>
          <FunctionRender
            node={node}
            onUpdateItem={onUpdateItem}
            onDeleteItem={onDeleteItem}
            onSelectHandler={selectItemsHandler}
            component={RecursiveRenderComponent}
            dropdownData={dropdownDataToComponent}
          />
          {withEndInput ? (
            <FormulaSelect
              onSelectItem={selectItemsHandler}
              dropdownData={dropdownDataToAdditionalInput}
            />
          ) : null}
        </>
      );
    case FormulaTree.NODE_TYPES.Brackets:
      return (
        <>
          <BracketsRender
            node={node}
            onSelectHandler={selectItemsHandler}
            component={RecursiveRenderComponent}
            dropdownData={dropdownDataToComponent}
          />
          {withEndInput ? (
            <FormulaSelect
              onSelectItem={selectItemsHandler}
              dropdownData={dropdownDataToAdditionalInput}
            />
          ) : null}
        </>
      );
    case FormulaTree.NODE_TYPES.Variable:
      return (
        <>
          <VariableComponent
            node={node}
            isActive={autoActiveInputs}
            onUpdateItem={onUpdateItem}
            onDeleteItem={onDeleteItem}
            onSelectHandler={selectItemsHandler}
            dropdownData={dropdownDataToComponent}
          />
        </>
      );
    case FormulaTree.NODE_TYPES.Value:
    case FormulaTree.NODE_TYPES.Constants:
      return (
        <>
          <VariableComponent
            node={node}
            onDeleteItem={onDeleteItem}
            onUpdateItem={onUpdateItem}
            onSelectHandler={selectItemsHandler}
            dropdownData={dropdownDataToComponent}
          />
        </>
      );
    case FormulaTree.NODE_TYPES.Operator:
      return (
        <>
          <OperatorComponent
            node={node}
            onUpdateItem={onUpdateItem}
            onDeleteItem={onDeleteItem}
            onSelectHandler={selectItemsHandler}
            dropdownData={dropdownDataToComponent}
          />
        </>
      );
    default:
      return <FormulaLabel onDeleteItem={onDeleteItem} onSelectItem={onSelectItem} node={node} />;
  }
};

export default NodeRender;
